import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface GenericList {
    id: number;
    name: string;
}

const ReportJobClaimStatusData = () => {
    let navigate = useNavigate();
    const [loading, setLoading] = React.useState(true);
    const [claimStatus, setClaimStatus] = React.useState<GenericList[]>([]);
    const [filter, setFilter] = React.useState({ startDate: "", endDate: "", claimStatusId: -1 });
    const [errors, setErrors] = React.useState("");

    React.useEffect(() => {
        getData();
    }, [])

    const getData = async () => {
        const user = await authService.getUser();
        const token = await authService.getAccessToken();
        axios.get('Users/CheckUserPermission?SubId=' + user.sub + '&Permission=RunJobClaimStatusReport', {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data === true) {
                axios.get('Jobs/GetClaimStatus', {
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
                })
                    .then(res => {
                        setClaimStatus(res.data);
                        setLoading(false);
                    })
                    .catch(error => {
                        toast.error(error.message);
                    });
            } else if (res.data === false) {
                //redirect to 403 permission denied
                navigate("/accessdenied");
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const handleChange = (e: any) => {
        setFilter(prevState => ({ ...prevState, [e.target.name]: e.target.value }));
        setErrors("");
    }

    const validate = () => {
        let error = "";
        let formIsValid = true;

        if (!filter.startDate) {
            formIsValid = false;
            error = "Start Date is required";
        }

        if (!filter.endDate) {
            formIsValid = false;
            if (error) {
                error += ", End Date is required";
            } else {
                error = "End Date is required";
            }
        }

        if (filter.startDate && filter.endDate && filter.endDate < filter.startDate) {
            formIsValid = false;
            if (errors) {
                error += ", Start Date must be < End Date";
            } else {
                error = "Start Date must be < End Date";
            }
        }

        if (!filter.claimStatusId || filter.claimStatusId < 1) {
            formIsValid = false;
            if (error) {
                error += ", Claim Status is required";
            } else {
                error = "Claim Status is required";
            }
        }

        setErrors(error);
        return formIsValid;
    }

    const runReport = (e: any) => {
        e.preventDefault();
        //run the report

        if (validate()) {
            var url = "/report/JobClaimStatus/" + filter.startDate + "/" + filter.endDate + "/" + filter.claimStatusId;
            window.open(url, '_blank');
        } else {
            toast.error("Please fix the validation issues before running report");
        }
    }

    const exportReportToExcel = (e: any) => {
        e.preventDefault();

        if (validate()) {
            exportToExcel();
        } else {
            toast.error("Please fix the validation issues before running report");
        }
    }

    const exportToExcel = async () => {
        const user = await authService.getUser();
        const token = await authService.getAccessToken();

        axios('Report/ExportJobClaimStatus?startDate=' + filter.startDate + "&endDate=" + filter.endDate + "&claimStatusId=" + filter.claimStatusId + "&subId=" + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },
            method: 'GET',
            responseType: 'blob' //Force to receive data in a Blob Format
        })
        .then(res => {
            //DOWNLOAD FILE TO BROWSER
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Claim Status.xlsx');
            document.body.appendChild(link);
            link.click();
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Job Claim Status (BAU/CAT) Report</h1>
            </div>
            <div className="marginTop20">
                <span>Select a Start Date, End Date and a Claim Status to run the report.</span>
            </div>
            <div>
                <label className="input-group" htmlFor="startDate">
                    <span className="label">Start Date</span>
                    <input type='date' id="startDate" name="startDate" className='input' value={filter.startDate} onChange={(e) => handleChange(e)}></input>
                </label>

                <label className="input-group" htmlFor="endDate">
                    <span className="label">End Date</span>
                    <input type='date' id="endDate" name="endDate" className='input' value={filter.endDate} onChange={(e) => handleChange(e)}></input>
                </label>

                <label className="input-group" htmlFor="claimStatusId">
                    <span className="label">Claim Status</span>
                    <select className="select" id="claimStatusId" name="claimStatusId" value={filter.claimStatusId} onChange={(e) => handleChange(e)}>
                        <option defaultValue="-1" value="-1"></option>
                        {claimStatus.map(status =>
                            <option key={status.id} value={status.id}>{status.name}</option>
                        )};
                    </select>
                </label>

                <button className="defaultbutton-prev defaultbutton-label" type='button' onClick={runReport}>Run Report</button>
                <button className="defaultbutton-next" type='button' onClick={exportReportToExcel}>Export to Excel</button>
            </div>
            <div>
                <span className="label errors report-error-align">{errors}</span>
            </div>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)
};

export default ReportJobClaimStatusData;